const cloneDeep = require('lodash/cloneDeep')
const get = require('lodash/get')

// This copies merges each product of a stock report
// - the second param's `fields` overwrite the first
// - the `commits` are merged, but if any of the `commits` are they same, the second param's `commit` will win
// - the `batches` are merged, but if any of the `batches` keys are the same, the second param's `batch` will win
module.exports = (prev, update, reportingPeriod) => {
  return Object.keys(update).reduce((acc, productId) => {
    const batches = update[productId].batches
    const fields = update[productId].fields
    const commits = update[productId].commits
    const prevProduct = get(acc, productId, {})

    let mergedBatches
    if (batches) {
      mergedBatches = Object.assign({}, prevProduct.batches, batches)
      // Stamp reportingPeriod only on the batches actually submitted here,
      // not the whole product - a submission is per-batch, so sibling
      // batches of the same product that weren't touched must keep theirs.
      if (reportingPeriod) {
        Object.keys(batches).forEach(batchId => {
          mergedBatches[batchId] = Object.assign({}, mergedBatches[batchId], { reportingPeriod })
        })
      }
    }

    acc[productId] = Object.assign(
      {},
      prevProduct,
      mergedBatches && { batches: mergedBatches },
      fields && { fields: { fields } },
      commits && { commits: Object.assign({}, prevProduct.commits, commits) }
    )
    return acc
  }, cloneDeep(prev) || {})
}
